import { useQuery } from '@tanstack/react-query'
import axios from 'axios'
import type { Contact } from '../../ContactManagement/types'

/**
 * Fetch all available Ironworker contacts for assignment
 */
export function useIronworkerPool() {
  return useQuery<Contact[], Error>({
    queryKey: ['ironworkerPool'],
    queryFn: async () => {
      const resp = await axios.get<{
        data: Contact[]
      }>('/api/myteconstruction/contacts', {
        params: {
          subtype: 'Ironworker',
          contactType: 'Ironworker',
          active: true,
          page: 1,
          limit: 1000
        }
      })
      return resp.data.data
    }
  })
}